import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Cookie } from "lucide-react";

export const CookieConsent = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("mm_cookie_consent")) setShow(true);
  }, []);

  const choose = (value) => {
    localStorage.setItem("mm_cookie_consent", value);
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label="Cookie consent"
      data-testid="cookie-consent"
      className="fixed bottom-0 inset-x-0 z-[60] bg-card/95 backdrop-blur border-t border-border shadow-2xl"
    >
      <div className="max-w-5xl mx-auto px-4 py-4 flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <Cookie className="w-6 h-6 text-primary shrink-0 hidden sm:block" aria-hidden="true" />
        <p className="text-sm text-muted-foreground flex-1">
          We use cookies to improve your experience and to show relevant ads via Google AdSense, which may be personalised.
          Read our <Link to="/privacy" className="text-primary underline font-medium">Privacy Policy</Link> to learn more or manage preferences.
        </p>
        <div className="flex gap-2 shrink-0 w-full sm:w-auto">
          <Button variant="outline" size="sm" className="flex-1 sm:flex-none rounded-full" data-testid="cookie-reject" onClick={() => choose("essential")}>
            Essential only
          </Button>
          <Button size="sm" className="flex-1 sm:flex-none rounded-full" data-testid="cookie-accept" onClick={() => choose("all")}>
            Accept all
          </Button>
        </div>
      </div>
    </div>
  );
};
